import { Component } from 'preact';

export default class Green extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <style dangerouslySetInnerHTML={{
                __html: `
                :root {
                    /* Global */
                    --brand-global-radius: 10px;

                    /* Colors */
                    --brand-color-background: #FFF;
                    --brand-color-secondary: #FFF;
                    --brand-color-border: #D7D5D2;
                    --brand-color-body: #3E3B38;
                    --brand-color-primary: #008643;
                    --brand-color-focus: #FFCC00;

                    /* Fonts */
                    --brand-font-family-title: "Futura Std", serif;
                    --brand-font-family-body: "Futura";
                    --brand-font-weight-regular: 400;
                    --brand-font-weight-bold: 700;

                    /* Title */
                    --brand-title-weight: 700;
                    --brand-title-transform: uppercase;
                    --brand-title-spacing: 0;

                    /* Input */
                    --brand-input-border-width: 2px;
                    --brand-input-border-color: #D7D5D2;

                    /* Button */
                    --brand-button-radius: 10px;
                    --brand-button-border-size: 0;
                    --brand-button-border-color: transparent;
                    --brand-button-font-color: #FFF;
                    --brand-button-font-size: 14px;
                    --brand-button-font-weight: 700;
                    --brand-button-font-transform: uppercase;
                    --brand-button-font-spacing: 1px;
                }
            `
            }}></style>

        );
    }
}